export default {
	namespaced: true,

	state: {
		isInitialized: false,

		id: null,
		oldSystemClientUserId: null,

		username: null,
		fullName: null,
		email: null,
		phone: null,
		postcode: null,
		address1: null,
		address2: null,
		profilePictureUrl: null,
		userGroupCode: null,
		userGroupName: null,
		securityGroupCode: null,
		securityGroupName: null,
		blocked: false,
		disabled: false,

		trainingData: [],
		pointData: {},

		training: { // this property is not in use (2020.10.27)
			new: {
				openedModule: {
					new: true
				},
				completedModule: {},
				openedSection: {},
				completedSection: {}
			}
		}
	},

	getters: {
		get: state => state
	},

	mutations: {
		setValue (state, [key, value]) {
			state[key] = value;
		},
		setSubValue (state, [key, subKey, value]) {
			state[key][subKey] = value;
		}
	},

	actions: {
	}
}
